import styled from "@emotion/styled";
import { css } from "@emotion/core";
import { NectarTheme } from "@nectarTypes";

export const IconContainer = styled.div<NectarTheme>`
  ${({ theme }) => css`
    border-radius: ${theme.spacings.xs};
    background-color: ${theme.colors.gray100};
  `}
`;

export const HeadingContainer = styled.div<NectarTheme>`
  ${({ theme }) => css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: ${theme.spacings.lg};
  `}
`;

export const MoreButtonContainer = styled.div<NectarTheme>`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: ${theme.spacings.md};
  `}
`;

export const FetchMoreErrorContainer = styled.div<NectarTheme>`
  ${({ theme }) => css`
    display: flex;
    justify-content: center;
    margin-top: ${theme.spacings.md};
  `}
`;
